import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { ApiHttpError } from '@/api/client';

function isUnauthorised(err: unknown): boolean {
  return err instanceof ApiHttpError && err.status === 401;
}

function redirectToLogin(): void {
  if (typeof window === 'undefined') return;
  const path = window.location.pathname + window.location.search;
  if (window.location.pathname === '/login') return;
  const next = encodeURIComponent(path);
  window.location.assign(`/login?next=${next}`);
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (err, query) => {
      // The 'auth.me' query handles its own 401 by returning null.
      if (query.queryKey[0] === 'auth' && query.queryKey[1] === 'me') return;
      if (isUnauthorised(err)) redirectToLogin();
    },
  }),
  mutationCache: new MutationCache({
    onError: (err) => {
      if (isUnauthorised(err)) redirectToLogin();
    },
  }),
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        const status = (error as { status?: number } | null)?.status;
        if (status === 401 || status === 403 || status === 404) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
      staleTime: 10_000,
    },
    mutations: { retry: false },
  },
});
